//DefaultTable

import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, gridClasses, GridToolbar } from '@mui/x-data-grid';
import { Button, Card, CardBody, CardTitle, CardFooter } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { FaPallet } from 'react-icons/fa';
import { FaBoxes } from 'react-icons/fa';
import { FaBox } from 'react-icons/fa';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'paletaBodega_Id';

export default function PaletasBodega_Table(props) {
    const [pageSize, setPageSize] = React.useState(25);
    const [rows, setRows] = React.useState(props.data);
    const [sortModel, setSortModel] = React.useState([
        {
            field: keyField,
            //field: 'error',
            sort: 'desc',
        },
    ]);
    const intl = useIntl();

    const columns = [
        {
            field: keyField,
            headerName: 'ID',
            width: 90,
            type: 'number',
            hide: true
        },
        {
            field: 'createdDate',
            headerName: intl.formatMessage({ id: 'Fecha de importacion' }),
            editable: false,
            width: 180,
            renderCell: (params) => {
                //return params.row['createdDate'].slice(0, 10)
                return new Date(params.row['createdDate']).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit', hour: 'numeric', minute: 'numeric' }).replace(",","");
            }

        },
        {
            field: 'archivo',
            headerName: intl.formatMessage({ id: 'Archivo' }),
            editable: false,
            width: 180,
        },
        {
            field: 'bodega',
            headerName: intl.formatMessage({ id: 'Bodega' }),
            editable: false,
            width: 80,
        },
        {
            field: 'productor',
            headerName: intl.formatMessage({ id: 'Productor' }),
            editable: false,
            width: 80,
        },
        {
            field: 'codigoTMU',
            headerName: intl.formatMessage({ id: 'CodigoTMU' }),
            editable: false,
            width: 120,
        },
        {
            field: 'timestamp',
            headerName: intl.formatMessage({ id: 'Timestamp' }),
            editable: false,
            width: 180,
            renderCell: (params) => {
                //return params.row['createdDate'].slice(0, 10)
                const timestamp = params.row['timestamp'];
                if (timestamp) {
                    const year = parseInt(timestamp.substr(0, 4));
                    const month = parseInt(timestamp.substr(4, 2)) - 1; // Months are zero-indexed
                    const day = parseInt(timestamp.substr(6, 2));
                    const hour = parseInt(timestamp.substr(8, 2));
                    const minute = parseInt(timestamp.substr(10, 2));
                    const second = parseInt(timestamp.substr(12, 2));
                    return new Date(year, month, day, hour, minute, second).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: '2-digit', hour: 'numeric', minute: 'numeric' }).replace(",", "");
                }
                else {
                    return null;
                }
            }
        },
        {
            field: 'estado',
            headerName: intl.formatMessage({ id: 'Estado' }),
            editable: false,
            width: 480,
            cellClassName: (params) => {
                var result = ''
                if (!params.row['estado'] || params.row['estado'] == '' || params.row['estado'] == 'Paleta Conectada') {
                    result = 'successColumn'
                }
                else if (params.row['estado'] == 'Entrada modificada' || params.row['estado'] == 'Entrada omitida') {
                    result = 'warningColumn'
                }
                else {
                    result = 'errorColumn'
                }
                return result;
            }
        },
        {
            field: 'entrada',
            headerName: intl.formatMessage({ id: 'Entrada' }),
            editable: false,
            width: 120,
        },
        {
            field: 'actions',
            headerName: '',
            sortable: false,
            editable: false,
            filterable: false,
            align: 'center',
            width: 60,
            hide: false,
            renderCell: (params) => {
                return (
                    <div>
                        <Tooltip title="Editar">
                            <IconButton className='DarkBlueButton GridButton' onClick={() => {
                                props.edit_onclick(params.row[keyField])
                            }}>
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                        {/*<Tooltip title="Eliminar">*/}
                        {/*    <IconButton className='RedButton GridButton' onClick={() => {*/}
                        {/*        props.delete_onclick(params.row[keyField])*/}
                        {/*    }}>*/}
                        {/*        <DeleteIcon />*/}
                        {/*    </IconButton>*/}
                        {/*</Tooltip>*/}
                    </div>

                )
            },
        },

    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        paletaBodega_Id: false,
        entrada: false
    });
    const labelToCountMap = {};

    rows.forEach(item => {
        const estado = item.estado;

        if (estado && estado.includes("Paletizado no encontrado")) {
            labelToCountMap["Paletizado no encontrado"] = (labelToCountMap["Paletizado no encontrado"] || 0) + 1;
        }
        if (estado && estado.includes("Entrada omitida")) {
            labelToCountMap["Entrada omitida"] = (labelToCountMap["Entrada omitida"] || 0) + 1;
        }
        if (estado && estado.includes("Formato equivocado")) {
            labelToCountMap["Formato equivocado"] = (labelToCountMap["Formato equivocado"] || 0) + 1;
        }
        if (estado && estado.includes("Semana equivocada")) {
            labelToCountMap["Semana equivocada"] = (labelToCountMap["Semana equivocada"] || 0) + 1;
        }
        if (estado && estado.includes("Entrada modificada")) {
            labelToCountMap["Entrada modificada"] = (labelToCountMap["Entrada modificada"] || 0) + 1;
        }
        if (estado && estado.includes("Paleta Conectada")) {
            labelToCountMap["Paleta Conectada"] = (labelToCountMap["Paleta Conectada"] || 0) + 1;
        }
    });
    return (
        <div>
            <div className="row p-3">
                <div className="col successColumn">{`Paleta Conectada: ${labelToCountMap["Paleta Conectada"] || 0}`}</div>
                <div className="col warningColumn">{`Entrada modificada: ${labelToCountMap["Entrada modificada"] || 0}`}</div>
                <div className="col warningColumn">{`Entrada omitida: ${labelToCountMap["Entrada omitida"] || 0}`}</div>
                <div className="col errorColumn">{`Formato equivocado: ${labelToCountMap["Formato equivocado"] || 0}`}</div>
                <div className="col errorColumn">{`Semana equivocada: ${labelToCountMap["Semana equivocada"] || 0}`}</div>
                <div className="col errorColumn">{`Paletizado no encontrado: ${labelToCountMap["Paletizado no encontrado"] || 0}`}</div>
            </div>
            <Toolbar>
                <div className="row" style={{ width: '100%' }}>
                    <div className="col">

                    </div>
                </div>
                <Button className="AddButton" style={{ whiteSpace: 'nowrap' }} onClick={() => {
                    props.add_onclick()
                }}><AddIcon /> Agregar Manualmente</Button>
            </Toolbar>
            <Box sx={{
                height: 600, width: '100%',
            }}>

                <StripedDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[25, 50]}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                    disableColumnFilter
                    disableColumnSelector
                    disableDensitySelector
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500, placeholder: 'Buscar' },
                            printOptions: { disableToolbarButton: true },
                        },
                    }}
                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Box>
        </div>
    );
}
